import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createUser, updateUser, selectUsers } from "./usersSlice";
import { checkFieldUpdate } from "../../common/utils";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { makeStyles, withStyles } from "@material-ui/core/styles";

import ListItemText from "@material-ui/core/ListItemText";

import Divider from "@material-ui/core/Divider";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink
  tabBar: {
    // backgroundColor: ' rgba(0, 0, 0, 0.08)',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    // alignItems: 'center',
    borderRadius: "10px",
    backgroundColor: "#FFF",
    padding: 0,
  },
  form: {
    // width: '100%', // Fix IE 11 issue.
    // marginTop: theme.spacing(1),
    // padding: 25,
  },
  linkText: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  headerContainer: {
    padding: theme.spacing(2),
    // color: '#fafafa',
    color: "#fff",
    backgroundColor: "#42494E",
  },
  subHeader: {
    margin: theme.spacing(2),
    marginBottom: 0,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#42494E",
    color: "#FFF",
  },
  tabContent: {
    display: "flex",
    flexFlow: "column nowrap",
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },

  outer: { display: "flex", flexFlow: "column" },
  addIcon: {
    marginRight: 8,
    color: "#fff",
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: " #42494E",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
  },
  textItem: {
    marginBottom: 16,
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

export default function User(props) {
  const { product } = props;
  const classes = useStyles();
  const { editing, user } = useSelector(selectUsers);

  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [editUser, setEditUser] = useState(false);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "active", name: "Active" },
    { id: 2, value: "inactive", name: "Inactive" },
    { id: 4, value: "deleted", name: "Deleted" },
    { id: 5, value: "pending", name: "Pending" },
  ]);

  const [roleList, setRoleList] = useState([
    { id: 1, value: "super_admin", name: "Super Admin" },
    { id: 2, value: "admin", name: "Admin" },
    { id: 3, value: "client", name: "Client" },
  ]);
  const [username, setUsername] = useState(editUser ? user.username : "");
  const [firstName, setFirstName] = useState(editUser ? user.firstName : "");
  const [lastName, setLastName] = useState(editUser ? user.lastName : "");
  const [displayName, setDisplayName] = useState(
    editUser ? user.displayName : ""
  );
  const [email, setEmail] = useState(editUser ? user.email : "");
  const [mobile, setMobile] = useState(editUser ? user.mobile : "");
  const [role, setRole] = useState(
    editUser ? roleList[user.roleID - 1].value : ""
  );
  const [roleID, setsRoleID] = useState(editUser ? user.roleID : "");
  const [statusID, setStatusID] = useState(editUser ? user.statusID : 1);
  const [status, setStatus] = useState(
    editUser ? statusList[user.statusID - 1].value : ""
  );

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const handleStatusChange = (event) => {
    let status = statusList.find(
      (status) => status.value === event.target.value
    );
    console.log(status.id);
    setStatusID(status.id);

    setStatus(event.target.value);
  };

  const handleRoleChange = (event) => {
    let role = roleList.find((role) => role.value === event.target.value);
    setsRoleID(role.id);

    setRole(event.target.value);
  };

  const validatePassword = () => {
    var conditions = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/;
    if (newPassword.match(conditions)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (editUser) {
      const updatedUser = checkFieldUpdate(
        [
          { name: "statusID", val: statusID },
          { name: "username", val: username },
          { name: "firstName", val: firstName },
          { name: "lastName", val: lastName },
          { name: "displayName", val: displayName },
          { name: "email", val: email },
          { name: "mobile", val: mobile },
          { name: "roleID", val: roleID },
        ],
        user
      );
      dispatch(updateUser({ token: jwtToken, id: user.id, user: updatedUser }));
    } else {
      if (!validatePassword()) {
        setPasswordError("Invalid password");
      } else if (newPassword !== confirmPassword) {
        setConfirmError("Passwords don't match");
      } else {
        setPasswordError("");
        setConfirmError("");

        const newUser = {
          statusId: statusID,
          username: username,
          firstName: firstName,
          lastName: lastName,
          displayName: displayName,
          email: email,
          mobile: mobile,
          // avatarImage: "abc.jpeg",
          roleID: roleID,
        };

        dispatch(
          createUser({
            token: jwtToken,
            user: { ...newUser, password: newPassword },
          })
        );
      }
    }
  };

  useEffect(() => {
    if (editing && user !== {}) {
      setEditUser(true);
      setUsername(user.username);
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setDisplayName(user.displayName);
      setEmail(user.email);
      setMobile(user.mobile);
      setRole(user.roleID ? roleList[user.roleID - 1].value : "");
      setsRoleID(user.roleID);
      setStatus(user.statusID ? statusList[user.statusID - 1].value : "");
      setStatusID(user.statusID);
      setNewPassword("");
      setConfirmPassword("");
      setPasswordError("");
      setConfirmError("");
      setOpen(true);
    }
  }, [editing, user]);

  const handleClickOpen = () => {
    setEditUser(false);
    setUsername("");
    setFirstName("");
    setLastName("");
    setDisplayName("");
    setEmail("");
    setMobile("");
    setRole("");
    setsRoleID("");
    setStatus("");
    setStatusID(1);
    setNewPassword("");
    setConfirmPassword("");
    setPasswordError("");
    setConfirmError("");
    setOpen(true);
  };

  const handleClose = () => {
    setEditUser(false);
    setUsername("");
    setFirstName("");
    setLastName("");
    setDisplayName("");
    setEmail("");
    setMobile("");
    setRole("");
    setsRoleID("");
    setStatus("");
    setStatusID(1);
    setNewPassword("");
    setConfirmPassword("");
    setPasswordError("");
    setConfirmError("");
    setOpen(false);
  };

  // const handleStatusChange = (event) => {
  //   let selectedStatus = statusList.filter(
  //     (status) => status.value === event.target.value
  //   );
  //   selectedStatus[0] && setStatusIDs(selectedStatus[0].id);

  //   setProductStatus(event.target.value);
  // };

  return (
    <div>
      <IconButton
        aria-label={editUser ? "edit user" : "add user"}
        style={product ? { marginLeft: 0 } : { marginLeft: 0 }}
      >
        <AddCircleIcon
          style={
            product ? { marginRight: 0 } : { marginRight: 0, color: "#fff" }
          }
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          {editUser ? "Edit User" : "Add User"}
        </DialogTitle>
        <form onSubmit={handleSubmit} className={classes.form}>
          <DialogContent>
            <DialogContentText style={{ paddingTop: 8, textAlign: "center" }}>
              {editUser ? "Update User Details" : "Enter User Details"}
            </DialogContentText>
            <div className={classes.tabContent}>
              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space between"
              >
                <Grid item sm>
                  <TextField
                    defaultValue={editUser ? user.firstName : ""}
                    autoFocus
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    id="firstName"
                    label="First Name"
                    name="firstName"
                    autoComplete="given-name"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={editUser ? user.lastName : ""}
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="family-name"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space between"
              >
                <Grid item sm>
                  <TextField
                    defaultValue={editUser ? user.username : ""}
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    id="username"
                    label="Username"
                    name="username"
                    autoComplete="username"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={editUser ? user.displayName : ""}
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    id="displayName"
                    label="Display Name"
                    name="displayName"
                    autoComplete="username"
                    onChange={(e) => setDisplayName(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space between"
              >
                <Grid item sm>
                  <TextField
                    defaultValue={editUser ? user.email : ""}
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={editUser ? user.mobile : ""}
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    id="mobile"
                    label="Phone Number"
                    name="mobile"
                    autoComplete="tel"
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </Grid>
                <Grid
                  item
                  sm
                  style={{
                    paddingTop: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl
                    fullWidth
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-status-simple">
                      User Role
                    </InputLabel>
                    <Select
                      style={{ maxHeight: 56 }}
                      // margin="dense"
                      value={role}
                      fullWidth
                      onChange={(e) => handleRoleChange(e)}
                      label="User Role"
                      inputProps={{
                        name: "role",
                        id: "outlined-role-simple",
                      }}
                    >
                      <MenuItem aria-label="None" value="">
                        <em>None</em>
                      </MenuItem>
                      {roleList.map((role) => (
                        <MenuItem key={role.id} value={role.value}>
                          <ListItemText primary={role.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {editUser && (
                  <Grid
                    item
                    sm
                    style={{
                      paddingTop: 20,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl
                      fullWidth
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-user-status-simple">
                        User Status
                      </InputLabel>
                      <Select
                        style={{ maxHeight: 56 }}
                        // margin="dense"
                        value={status}
                        fullWidth
                        onChange={(e) => handleStatusChange(e)}
                        label="Status"
                        inputProps={{
                          name: "status",
                          id: "outlined-status-simple",
                        }}
                      >
                        {statusList.map((status) => (
                          <MenuItem key={status.id} value={status.value}>
                            <ListItemText primary={status.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>

              {!editUser && (
                <Grid>
                  <Grid className={classes.subHeader}>
                    <Typography variant="body2">
                      Passwords must be longer than 8 characters and contain at
                      least one number and one special character
                    </Typography>
                  </Grid>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    name="new-password"
                    label="Password"
                    type="password"
                    id="new-password"
                    autoComplete="new-password"
                    inputProps={{ minLength: 8, maxLength: 99 }}
                    onChange={(e) => setNewPassword(e.target.value)}
                    error={passwordError}
                    helperText={passwordError ? passwordError : ""}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required={!editUser}
                    fullWidth
                    name="confirm-password"
                    label="Confirm Password"
                    type="password"
                    id="confirm-password"
                    autoComplete="new-password"
                    inputProps={{ minLength: 8, maxLength: 99 }}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={confirmError}
                    helperText={confirmError ? confirmError : ""}
                  />
                </Grid>
              )}
            </div>
          </DialogContent>
          <Divider />
          <DialogActions
            style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 16 }}
          >
            <Grid container spacing={2} direction="row">
              <Grid item sm>
                <ColorButton onClick={handleClose} color="primary">
                  Cancel
                </ColorButton>
              </Grid>
              <Grid item sm>
                <ColorButton
                  type="submit"
                  // onClick={editUser ? handleUpdate : handleCreate}
                  // onClick={handleSubmit}
                  color="secondary"
                >
                  {editUser ? "Edit User" : "Create User"}
                </ColorButton>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
